import React from "react";
import { ListGroup, ListGroupItem, Badge } from "reactstrap";
/* import UnsplashLogo from "../../assets/icons/unsplash_logo.svg"; */
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import unsplashLogo from "../../../assets/icons/unsplash_logo.svg";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import PhotoLibraryOutlinedIcon from "@material-ui/icons/PhotoLibraryOutlined";
import { archiveConstants } from "../contstants/archive.contstants";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import FontDownloadOutlinedIcon from "@material-ui/icons/FontDownloadOutlined";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

export function FileStorageList(props) {
  const classes = useStyles();
  const { files, navigate, display } = props;
  return (
    <List
      className="dark-l3"
      style={{
        width: "100%",
        minWidth: 360,
        paddingTop: 0,
        maxWidth: 360,
      }}
    >
      <ListItem
        className={
          "storage-li" + (display === archiveConstants.IMAGE ? " sel" : "")
        }
        onClick={() =>
          navigate(archiveConstants.IMAGE, archiveConstants.IMAGE_TYPES)
        }
      >
        <ListItemIcon className="primary-text">
          <PhotoLibraryOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          className="primary-text"
          primary={<SystemLabel name="Images" />}
        />
        <ListItemSecondaryAction className="primary-text">
          {files
            ? files.filter((o) => {
                return (
                  archiveConstants.IMAGE_TYPES.includes(
                    o.type.substring(o.type.lastIndexOf("/") + 1)
                  ) && o
                );
              }).length
            : 0}
        </ListItemSecondaryAction>
      </ListItem>
      <ListItem
        className={
          "storage-li" + (display === archiveConstants.OTHER ? " sel" : "")
        }
        onClick={() =>
          navigate(archiveConstants.OTHER, archiveConstants.OTHER_TYPES)
        }
      >
        <ListItemIcon className="primary-text">
          <InsertDriveFileOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          className="primary-text"
          primary={<SystemLabel name="OtherFiles" />}
        />
        <ListItemSecondaryAction className="primary-text">
          {files
            ? files.filter((o) => {
                return (
                  o &&
                  !archiveConstants.IMAGE_TYPES.includes(
                    o.type.substring(o.type.lastIndexOf("/") + 1)
                  ) &&
                  !archiveConstants.FONT_TYPES.includes(
                    o.type.substring(o.type.lastIndexOf("/") + 1)
                  )
                );
              }).length
            : 0}
        </ListItemSecondaryAction>
      </ListItem>

      <ListItem
        className={
          "storage-li" + (display === archiveConstants.UNSPLASH ? " sel" : "")
        }
        onClick={() =>
          navigate(archiveConstants.UNSPLASH, archiveConstants.UNSPLASH)
        }
      >
        <ListItemIcon>
          <img src={unsplashLogo} style={{ width: 24, height: 24 }} />
        </ListItemIcon>
        <ListItemText
          className="primary-text"
          primary={<SystemLabel name="Unsplash" />}
        />
      </ListItem>
      <ListItem
        className={
          "storage-li" + (display === archiveConstants.FONT ? " sel" : "")
        }
        onClick={() =>
          navigate(archiveConstants.FONT, archiveConstants.FONT_TYPES)
        }
      >
        <ListItemIcon className="primary-text">
          <FontDownloadOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          className="primary-text"
          primary={<SystemLabel name="UploadedFonts" />}
        />
        <ListItemSecondaryAction className="primary-text">
          {files
            ? files.filter((o) => {
                return (
                  archiveConstants.FONT_TYPES.includes(
                    o.type.substring(o.type.lastIndexOf("/") + 1)
                  ) && o
                );
              }).length
            : 0}
        </ListItemSecondaryAction>
      </ListItem>
    </List>
  );
}
